import React from "react";
import TripRequestsContent from "../components/leads/trip-requests-content";

const TripRequests = () => {
  return <TripRequestsContent />;
};

export default TripRequests;
